import {BaseEntity} from './base-entity';
import {Customer} from './customer';
import {AppUser} from './app-user';
import {CustomerRisk} from './customer-risk';


export class RiskAssementInquiry extends BaseEntity {

  public customer: CustomerRisk;
  public customerId: number;

  public inquiryUser: AppUser;

  public finishedUser: AppUser;

  public inquiryComment: string;
  public inquiryDate: Date;

  public finishedDate: Date;
  public finishedComment: string;

  public isFinished: boolean;

  public beforeRiskLevel: number;
  public finishedRiskLevel: number;

}
